/**
 * Hook personalizado para detectar scroll
 */

import { useState, useEffect, useCallback } from 'react';

/**
 * Hook para detectar si el usuario ha hecho scroll
 * @param {number} threshold - Umbral de scroll en píxeles
 * @returns {boolean} - true si el scroll supera el umbral
 */
export const useScrollDetection = (threshold = 20) => {
  const [isScrolled, setIsScrolled] = useState(false);

  const handleScroll = useCallback(() => {
    setIsScrolled(window.scrollY > threshold);
  }, [threshold]);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    // Verificar estado inicial
    handleScroll();
    
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  return isScrolled;
};

export default useScrollDetection;
